<template>
  <div class="hb-service-record-list">
    <div class="main-wrapper" id="abroad_show_service_collaboration">
      <div class="top-wrapper">
        <h4 class="center">{{tab_name}}</h4>
        <el-form :inline="true" class="form" style="text-align: left">
          <el-form-item label="">
            <el-button
              size="small"
              type="primary"
              @click="add"
            >添加关联素材</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="scroll-wrapper">
        <div v-if="showAssociationList.academic_projects.length > 0">
          <h4 style="font-size: 16px;font-weight: 700;margin-top: 10px">学术项目：</h4>
          <div class="box-card-wrapper" v-for="(item,index) in showAssociationList.academic_projects" :key="item.id">
            <div class="box-card-wrapper-content" style="width: 100%">
              <div>
                <el-popconfirm
                  title="是否确认删除？"
                  @confirm="del_project_association(item.id)"
                >
                  <span slot="reference" class="span_del">删除</span>
                </el-popconfirm>
                <span style="font-weight: 700">名称：</span>{{item.con.name}}</div>
              <div  v-if="item.con.time"><span style="font-weight: 700">时间：</span>{{getTime(item.con.time)}}</div>
              <div><span style="font-weight: 700">类型：</span>{{item.con.type}}</div>
              <div><span style="font-weight: 700">项目描述：</span>
                <span v-if="item.con.describe.length >150">
                   <span v-if="!item.expanded">
                    {{ getPreviewContent(item.con.describe) }}
                       <el-link type="primary"  @click="toggleContent(index,'academic_projects')">{{ item.expanded ? '收起' : '显示全部' }}</el-link>
                  </span>
                  <span v-if="item.expanded">
                    {{item.con.describe}}
                    <el-link type="primary"  @click="toggleContent(index,'academic_projects')">{{ item.expanded ? '收起' : '显示全部' }}</el-link>
                  </span>
                </span>
                <span v-if="item.con.describe.length <150">
                  {{item.con.describe}}
                </span>
              </div>
              <div v-if="item.con.type == '论文'"><span style="font-weight: 700">期刊号：</span>{{item.con.outcome}}</div>
              <div v-if="item.con.fileList && item.con.fileList.length > 0" style="display: flex">
                <div><span style="font-weight: 700">附件：</span></div>
                <div>
                  <div v-for="ite in item.con.fileList">
                    <el-link :underline="false" type="primary" @click="()=> {previewUrl=ite.url;previewName=ite.name}">
                      {{ite.name}}
                      <i style="color: #0e90d2;font-size: 18px;margin-left: 10px" class="el-icon-download"></i>
                    </el-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showAssociationList.work_experience.length > 0">
          <h4 style="font-size: 16px;font-weight: 700;margin-top: 10px">实习/工作经历：</h4>
          <div class="box-card-wrapper" v-for="(item,index) in showAssociationList.work_experience" :key="item.id">
            <div class="box-card-wrapper-content" style="width: 100%">
              <div>
                <el-popconfirm
                  title="是否确认删除？"
                  @confirm="del_project_association(item.id)"
                >
                  <span slot="reference" class="span_del">删除</span>
                </el-popconfirm>
                <span style="font-weight: 700">公司：</span>{{item.con.corporation_name}}</div>
              <div  v-if="item.con.time"><span style="font-weight: 700">时间：</span>{{getTime(item.con.time)}}</div>
              <div><span style="font-weight: 700">类型：</span>{{item.con.type}}</div>
              <div><span style="font-weight: 700">职位：</span>{{item.con.position}}</div>
              <div><span style="font-weight: 700">负责内容：</span>
                <span v-if="item.con.responsibility.length >150">
                  <span v-if="!item.expanded">
                  {{ getPreviewContent(item.con.responsibility) }}
                  <el-link type="primary"  @click="toggleContent(index,'academic_projects')">{{ item.expanded ? '收起' : '显示全部' }}</el-link>
                </span>
                    <span v-if="item.expanded">
                  {{ item.con.responsibility }}
                  <el-link type="primary"  @click="toggleContent(index,'academic_projects')">{{ item.expanded ? '收起' : '显示全部' }}</el-link>
                </span>
                </span>
                <span v-if="item.con.responsibility.length <150">
                   {{ item.con.responsibility }}
                </span>
              </div>
              <div v-if="item.con.fileList && item.con.fileList.length > 0" style="display: flex">
                <div><span style="font-weight: 700">附件：</span></div>
                <div>
                  <div v-for="ite in item.con.fileList">
                    <el-link :underline="false" type="primary" @click="()=> {previewUrl=ite.url;previewName=ite.name}">
                      {{ite.name}}
                      <i style="color: #0e90d2;font-size: 18px;margin-left: 10px" class="el-icon-download"></i>
                    </el-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showAssociationList.honorary_rewards.length > 0">
          <h4 style="font-size: 16px;font-weight: 700;margin-top: 10px">荣誉奖励：</h4>
          <div class="box-card-wrapper" v-for="(item,index) in showAssociationList.honorary_rewards" :key="item.id">
          <div class="box-card-wrapper-content" style="width: 100%">
            <div>
              <el-popconfirm
                title="是否确认删除？"
                @confirm="del_project_association(item.id)"
              >
                <span slot="reference" class="span_del">删除</span>
              </el-popconfirm>
              <span style="font-weight: 700">名称：</span>{{item.con.name}}</div>
            <div  v-if="item.con.time"><span style="font-weight: 700">时间：</span>{{getTime(item.con.time)}}</div>
            <div><span style="font-weight: 700">类型：</span>{{item.con.type}}</div>
            <div><span style="font-weight: 700">项目描述：</span>
              <span v-if="item.con.content.length >150">
                <span v-if="!item.expanded">
                  {{ getPreviewContent(item.con.content) }}
                  <el-link type="primary"  @click="toggleContent(index,'academic_projects')">{{ item.expanded ? '收起' : '显示全部' }}</el-link>
                </span>
                <span v-if="item.expanded">
                  {{ item.con.content }}
                  <el-link type="primary"  @click="toggleContent(index,'academic_projects')">{{ item.expanded ? '收起' : '显示全部' }}</el-link>
                </span>
              </span>
              <span  v-if="item.con.content.length <150">
                {{ item.con.content }}
              </span>
            </div>
            <div v-if="item.con.fileList && item.con.fileList.length > 0" style="display: flex">
              <div><span style="font-weight: 700">附件：</span></div>
              <div>
                <div v-for="ite in item.con.fileList">
                  <el-link :underline="false" type="primary" @click="()=> {previewUrl=ite.url;previewName=ite.name}">
                    {{ite.name}}
                    <i style="color: #0e90d2;font-size: 18px;margin-left: 10px" class="el-icon-download"></i>
                  </el-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div v-if="showAssociationList.extracurricular_activities.length > 0">
          <h4 style="font-size: 16px;font-weight: 700;margin-top: 10px">课外活动：</h4>
          <div class="box-card-wrapper" v-for="(item,index) in showAssociationList.extracurricular_activities" :key="item.id">
          <div class="box-card-wrapper-content" style="width: 100%">
            <div>
              <el-popconfirm
                title="是否确认删除？"
                @confirm="del_project_association(item.id)"
              >
                <span slot="reference" class="span_del">删除</span>
              </el-popconfirm>
              <span style="font-weight: 700">名称：</span>{{item.con.name}}</div>
            <div  v-if="item.con.time"><span style="font-weight: 700">时间：</span>{{getTime(item.con.time)}}</div>
            <div><span style="font-weight: 700">内容：</span>
              <span v-if="item.con.content.length >150">
                 <span v-if="!item.expanded">
                  {{ getPreviewContent(item.con.content) }}
                 <el-link type="primary"  @click="toggleContent(index,'academic_projects')">{{ item.expanded ? '收起' : '显示全部' }}</el-link>
                </span>
                <span v-if="item.expanded">
                  {{ item.con.content }}
                  <el-link type="primary"  @click="toggleContent(index,'academic_projects')">{{ item.expanded ? '收起' : '显示全部' }}</el-link>
                </span>
              </span>
              <span v-if="item.con.content.length <150">
                {{ item.con.content }}
              </span>
            </div>
            <div><span style="font-weight: 700">是否有证书：</span>{{item.con.certificate==1?'有证书':'没有证书'}}</div>
            <div v-if="item.con.fileList && item.con.fileList.length > 0" style="display: flex">
              <div><span style="font-weight: 700">附件：</span></div>
              <div>
                <div v-for="ite in item.con.fileList">
                  <el-link :underline="false" type="primary" @click="()=> {previewUrl=ite.url;previewName=ite.name}">
                    {{ite.name}}
                    <i style="color: #0e90d2;font-size: 18px;margin-left: 10px" class="el-icon-download"></i>
                  </el-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <el-dialog
      @close="clear"
      :visible.sync="dialogFormVisible"
    >
      <template #title>
        <h1 style="text-align: center;font-size: 16px;font-weight: 700;margin-top: 10px">添加素材</h1>
      </template>
      <h4 style="font-size: 16px;font-weight: 700;margin-top: 10px">学术项目：</h4>
      <el-checkbox-group v-model="choiceList.list_academic_projects">
        <p v-for="item in associationList.academic_projects">
          <el-checkbox :label="item.id" :key="item.id" v-model="item.id">{{item.name}}</el-checkbox>
        </p>
      </el-checkbox-group>
      <h4 style="font-size: 16px;font-weight: 700;margin-top: 10px">实习/工作经历：</h4>
      <el-checkbox-group v-model="choiceList.list_work_experience">
        <p v-for="item in associationList.work_experience">
          <el-checkbox :label="item.id" :key="item.id" v-model="item.id">{{item.name}}</el-checkbox>
        </p>
      </el-checkbox-group>
      <h4 style="font-size: 16px;font-weight: 700;margin-top: 10px">荣誉奖励：</h4>
      <el-checkbox-group v-model="choiceList.list_honorary_rewards">
        <p v-for="item in associationList.honorary_rewards">
          <el-checkbox :label="item.id" :key="item.id" v-model="item.id">{{item.name}}</el-checkbox>
        </p>
      </el-checkbox-group>
      <h4 style="font-size: 16px;font-weight: 700;margin-top: 10px">课外活动：</h4>
      <el-checkbox-group v-model="choiceList.list_extracurricular_activities">
        <p v-for="item in associationList.extracurricular_activities">
          <el-checkbox :label="item.id" :key="item.id" v-model="item.id">{{item.name}}</el-checkbox>
        </p>
      </el-checkbox-group>
      <div slot="footer" align="center" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>

        <el-popconfirm
          title="是否确认保存关联数据"
          @confirm="save()"
        >
          <el-button type="primary" slot="reference">确 定</el-button>
        </el-popconfirm>
      </div>
    </el-dialog>
    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl=null;previewName=null"/>

  </div>
</template>
<script>

import {getUserProjectAssociationList, getProjectAssociationList, addProjectAssociation, delProjectAssociation} from "@/api/mycenter_studyabroad";

import moment from 'moment';
import HBFilePreview from "@/components/HBCommon/HBFilePreview/HBFilePreview.vue";

export default {
  name: "abroad_show_service_collaboration",
  props: {},
  components: {
    HBFilePreview
  },
  data() {
    return {
      dialogFormVisible: false,
      showAssociationList: {
        academic_projects: [],
        work_experience: [],
        honorary_rewards: [],
        extracurricular_activities: []
      },
      associationList: {
        academic_projects: [],
        work_experience: [],
        honorary_rewards: [],
        extracurricular_activities: []
      },
      choiceList: {
        list_academic_projects: [],
        list_work_experience: [],
        list_honorary_rewards: [],
        list_extracurricular_activities: []
      },
      tab_name: '社科',
      previewUrl: null,
      previewName: null,
    };
  },
  methods: {
    toggleContent(index,_type) {
      if (_type == 'honorary_rewards') {
        this.showAssociationList.honorary_rewards[index].expanded = !this.showAssociationList.honorary_rewards[index].expanded
      }
      if (_type == 'extracurricular_activities') {
        this.showAssociationList.extracurricular_activities[index].expanded = !this.showAssociationList.extracurricular_activities[index].expanded
      }
      if (_type == 'work_experience') {
        this.showAssociationList.work_experience[index].expanded = !this.showAssociationList.work_experience[index].expanded
      }
      if (_type == 'academic_projects') {
        this.showAssociationList.academic_projects[index].expanded = !this.showAssociationList.academic_projects[index].expanded
      }
    },
    getPreviewContent(content) {
      return content.substring(0, 100) + '...'
    },
    getProjectAssociationList(tab_name) {
      this.clear()
      getProjectAssociationList(tab_name).then((res) => {
        let that = this
        res.data.forEach(function(item, index) {
          if (item.class == 'academic_projects') {
            that.associationList.academic_projects.push(item)
          }
          if (item.class == 'work_experience') {
            that.associationList.work_experience.push(item)
          }
          if (item.class == 'honorary_rewards') {
            that.associationList.honorary_rewards.push(item)
          }
          if (item.class == 'extracurricular_activities') {
            that.associationList.extracurricular_activities.push(item)
          }
          if (item.class == 'academic_projects' && item.checked) {
            that.choiceList.list_academic_projects.push(item.id)
          }
          if (item.class == 'work_experience' && item.checked) {
            that.choiceList.list_work_experience.push(item.id)
          }
          if (item.class == 'honorary_rewards' && item.checked) {
            that.choiceList.list_honorary_rewards.push(item.id)
          }
          if (item.class == 'extracurricular_activities' && item.checked) {
            that.choiceList.list_extracurricular_activities.push(item.id)
          }
        })
        this.choiceList = that.choiceList
      })
    },
    getUserProjectAssociationList() {
      getUserProjectAssociationList(this.tab_name).then((res) => {
        let that = this
        this.showAssociationList.academic_projects = []
        this.showAssociationList.work_experience = []
        this.showAssociationList.honorary_rewards = []
        this.showAssociationList.extracurricular_activities = []
        res.data.forEach(function(item, index) {
          if (item.class == 'academic_projects') {
            that.showAssociationList.academic_projects.push(item)
          }
          if (item.class == 'work_experience') {
            that.showAssociationList.work_experience.push(item)
          }
          if (item.class == 'honorary_rewards') {
            that.showAssociationList.honorary_rewards.push(item)
          }
          if (item.class == 'extracurricular_activities') {
            that.showAssociationList.extracurricular_activities.push(item)
          }
        })
        this.month('academic_projects')
        this.month('work_experience')
        this.month('honorary_rewards')
        this.month('extracurricular_activities')
      })
    },

    month(_type) {
      let len = 0
      let arr = []
      if (_type === 'work_experience') {
        len = this.showAssociationList.work_experience.length
        arr = this.showAssociationList.work_experience
      }
      if (_type === 'academic_projects') {
        len = this.showAssociationList.academic_projects.length
        arr = this.showAssociationList.academic_projects
      }
      if (_type === 'honorary_rewards') {
        len = this.showAssociationList.honorary_rewards.length
        arr = this.showAssociationList.honorary_rewards
      }
      if (_type === 'extracurricular_activities') {
        len = this.showAssociationList.extracurricular_activities.length
        arr = this.showAssociationList.extracurricular_activities
      }
      for (let i = 0; i < len; i++) {
        for (let j = 0; j < len - 1 - i; j++) {
          let time1
          if (!arr[j]['con']['time'] || arr[j]['con']['time'].length == 0) {
            time1 = 0
          } else {
            let date = new Date(arr[j]['con']['time'][0])
            time1 = new Date(date).getTime()
          }
          let time2
          if (!arr[j + 1]['con']['time'] || arr[j + 1]['con']['time'].length == 0) {
            time2 = 0
          } else {
            let date2 = new Date(arr[j+1]['con']['time'][0])
            time2 = new Date(date2).getTime()
          }
          if (time1 < time2) {
            let temp = arr[j]
            arr[j] = arr[j + 1]
            arr[j + 1] = temp
          }
        }
      }
      if (_type === 'work_experience') {
        this.showAssociationList.work_experience = arr
      }
      if (_type === 'academic_projects') {
        this.showAssociationList.academic_projects = arr
        console.log('this.showAssociationList',this.showAssociationList)
      }
      if (_type === 'honorary_rewards') {
        this.showAssociationList.honorary_rewards = arr
      }
      if (_type === 'extracurricular_activities') {
        this.showAssociationList.extracurricular_activities = arr
      }
    },
    save() {
      addProjectAssociation({ tab_name: this.tab_name, list: this.choiceList}).then((res) => {
        this.dialogFormVisible = false;
        this.getUserProjectAssociationList()
        this.getProjectAssociationList(this.tab_name)
      })
    },
    add() {
      this.getProjectAssociationList(this.tab_name)
      this.dialogFormVisible = true
    },
    clear() {
      this.choiceList.list_academic_projects = []
      this.choiceList.list_work_experience = []
      this.choiceList.list_honorary_rewards = []
      this.choiceList.list_extracurricular_activities = []
      this.associationList.academic_projects = []
      this.associationList.work_experience = []
      this.associationList.honorary_rewards = []
      this.associationList.extracurricular_activities = []
    },
    sendItem(tab_name) {
      this.tab_name = tab_name
      console.log('this.tab_name',this.tab_name)
      this.getUserProjectAssociationList()
      this.getProjectAssociationList(tab_name)
    },
    getTime(_time) {
      let start = moment(_time[0]).format('YYYY-MM-DD')
      let end = moment(_time[0]).format('YYYY-MM-DD')
      return start + '~' + end
    },
    del_project_association(_id) {
      delProjectAssociation({ id: _id }).then((res) => {
        this.getUserProjectAssociationList()
      })
    }


  },
};
</script>

<style lang="scss" scoped>
.scroll-wrapper h3{
  padding-left: 1rem;
}
.box-card-wrapper-content{
  font-size: 0.9rem;
}
.hb-service-record-list {
  height: 100%;
  .span_del{
    border-radius: 3px;
    background: red;
    color: white;
    font-size: 14px;
    padding: 2px 5px;
  }
  .main-wrapper {
    border: 1px solid #f2f6fc;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .top-wrapper {
      h4{
        border-bottom: solid 1px #e8e6e5;
        padding: 1rem 0;
        margin: 0;
      }
      border-bottom: solid 1px #e8e6e5;
      width: 100%;
      .el-form-item {
          margin-bottom: 0 !important;
        }
      .form {

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;

      }
    }
    .scroll-wrapper {
      width: 100%;
      flex: 1;
      overflow: scroll;
      .box-card-wrapper {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 5px;
        border-bottom: solid 1px #f2f6fc;
        padding: 5px 15px;
        .column-item {
          word-break: break-all;
          font-size: 14px;
          margin: 3px 0px;
          color: #333;
          .label {
            color: #909399;
          }
          .warning-item {
            width: 6px;
            height: 6px;
            background-color: red;
            border-radius: 3px;
            display: inline-block;
          }
        }
      }
    }
    .handle-wrapper {
      width: 100%;
      padding: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      .btn-item {
        display: block;
      }
    }
  }
  #abroad_show_service_collaboration {
    // position: absolute;
    // overflow: auto;
    height: 100%;
    // box-sizing: border-box;
    // border-bottom: 1px solid #fdfbfb;
    // scroll-snap-type: y mandatory;
  }
  .center {
    text-align: center;
  }
  .text {
    font-size: 14px;
  }
  .item {
    padding: 18px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/abroad_show_project_association.vue